"use client";

import { twMerge } from "tailwind-merge";

export const MyContentBackground = () => {
  return (
    <div className="sticky inset-x-0 top-0 h-0">
      <div
        className={twMerge(
          "h-[245px] bg-gradient-to-l from-zinc-900 to-sky-700 bg-fixed"
        )}
      />
    </div>
  );
};
